import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronRightSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-right-small"} maskId="square-filled-radius-0-stroke-1-IconChevronRightSmall"><path fillRule="evenodd" clipRule="evenodd" d="M10.0001 7.29297L14.7072 12.0001L10.0001 16.7072L9.29297 16.0001L13.293 12.0001L9.29297 8.00008L10.0001 7.29297Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronRightSmall;
